import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access } from './schemas/common.js';
const c = initContract();
/**
 * The only unauthenticated route: a load balancer cannot hold an API key — and
 * because anyone may call it, it says the one thing a load balancer needs and
 * nothing a stranger can use. Whether the database is up, and how long this
 * process has been running, is an operator's answer: `/health/details`, viewer.
 */
export const healthContract = c.router({
    check: {
        method: 'GET',
        metadata: access('public'),
        path: '/health',
        summary: 'Liveness. Public, and deliberately bare',
        responses: { 200: z.object({ status: z.literal('ok') }) },
    },
});
export const healthDetailsContract = c.router({
    details: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/health/details',
        summary: 'Liveness with the database round-trip and this process’s uptime',
        responses: {
            200: z.object({
                status: z.enum(['ok', 'degraded']),
                database: z.enum(['up', 'down']),
                uptimeSeconds: z.number(),
            }),
        },
    },
});
//# sourceMappingURL=health.contract.js.map